<div class="container">

  <div *ngIf="showDetailDialog">
    <p-dialog
      header="Log"
      [(visible)]="showDetailDialog"
      [modal]="true"
      [style]="{width: '90vw', height: '90vh'}"
      [draggable]="false"
      [resizable]="false"
    >
      <ng-container *ngIf="selectedLogContent; else emptyContent">
      <pre style="white-space: pre-wrap; word-wrap: break-word;">
        {{ selectedLogContent }}
      </pre>
      </ng-container>
      <ng-template #emptyContent>
        <div>
          <p>{{ 'extlog.detaiLogEmpty' | translate }}</p>
        </div>
      </ng-template>
    </p-dialog>
  </div>

  <table #actiontable data-testid="actiontable" class="detail-tab actiontable" *ngIf="extlogDetails">
    <thead>
      <tr>
        <th>{{ 'ID' }}</th>
        <th class="pl-4" colspan="2">{{ 'extlog.operation' | translate }}</th>
        <th>{{ 'extlog.time' | translate }}</th>
        <th>{{ 'extlog.idFlow' | translate }}</th>
        <th>{{ 'extlog.idJob' | translate }}</th>
        <th style="text-align: center;">{{ 'extlog.processedRecords' | translate }}</th>
        <th style="text-align: center;">{{ 'extlog.task' | translate }}</th>
        <th style="text-align: center;">{{ 'extlog.status' | translate }}</th>
        <th style="width: 100px;"></th>
      </tr>
    </thead>
    <br>
    <tbody>

      <tr *ngFor="let extlogDetail of extlogDetails; let i=index;">
        <td>{{ extlogDetail.id }}</td>
        <td class="pl-4" colspan="2">{{ extlogDetail.operation }}</td>
        <td> {{ extlogDetail.ts | date:'dd/MM/yyyy HH:mm:ss' }}</td>
        <td> {{ extlogDetail.idFlow }}</td>
        <td> {{ extlogDetail.idJob }}</td>
        <td style="text-align: center;">{{ extlogDetail.numRecords }}</td>
        <td style="text-align: center;">{{ extlogDetail.task}}</td>
        <td>
          <div class="detail-btn-container">
            <button class="status-button " [ngClass]="getStatusClass(extlogDetail.taskStatus)">
              {{extlogDetail.taskStatus === '0' ? 'SUCCESS' : 'ERROR'}}
            </button>
          </div>
        </td>
        <td>
          <div class="detail-btn-container"  *ngIf="extlogDetail.log !== null && extlogDetail.log !== '' " >
            <button class="btn-details" (click)="onOpenDetailDialog(extlogDetail.log)" style="cursor: pointer;">
              <i class="pi pi-eye"></i>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>



// WEBPACK FOOTER //
// ./src/app/views/extlog/extlog/extlog-table/extlog-table.component.html